import { detect } from 'detect-browser';
import { createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import generateIDs from './middleware/generateIDs';
import autoSave from './middleware/autoSave';
import sockets from './middleware/sockets';
import addBlockCheck from './middleware/addBlockCheck';
import SocketClient from './common/socketClient';
import reducer from './reducers';
import configs from './constants/configs';

const socket = new SocketClient();

const composeMiddleWares = (withDevTools) => {
    const browser = detect();
    const isChrome = browser && browser.name === 'chrome';
    const actionSanitizer = (action) => {
        // to optimize excessive use of memory and CPU during development
        const { type, payload } = action;
        if (type && payload && JSON.stringify(payload).length > 100) {
            return { ...action, payload: '<<HUGE_PAYLOAD_BLOB>>' };
        }

        return action;
    };

    const stateSanitizer = (state) => ({
        ...state,
        canvasBlocks: '<<HUGE_DATA_BLOB>>', // comment this whenever you want to test canvas blocks in redux dev tools
        htmlOutput: '<<HUGE_DATA_BLOB>>',
    });

    const composeEnhancers = composeWithDevTools({
        // trace: true, // enables tracing action origin in devtools. affects performance
        traceLimit: 25,
        actionSanitizer,
        stateSanitizer,
    });

    if (isChrome && withDevTools) {
        return composeEnhancers(
            applyMiddleware(generateIDs, autoSave, sockets(socket), addBlockCheck),
        );
    }

    return compose(applyMiddleware(generateIDs, autoSave, sockets(socket), addBlockCheck));
};

const configureStore = {
    TESTING: () => {
        const store = createStore(reducer, composeMiddleWares(true));
        return store;
    },
    STAGING: () => {
        const store = createStore(reducer, composeMiddleWares(false));
        return store;
    },
    PRODUCTION: () => {
        const store = createStore(reducer, composeMiddleWares(false));
        return store;
    },
};

export default configureStore[configs.ENVIRONMENT]();
